import React, {useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';
import {postSysOperationLogWord} from "../../api/apiClient";

const operationLogUpload = ({
                              hClose,
                              propStdde
                            }) => {

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [operationLogInfo, setOperationLogInfo] = useState({
    file: null,
    stdde: propStdde
  });

  const onChangeInfo = (name, value, isMany = false) => {
    let newInfo = {...operationLogInfo};
    if (isMany) {
      for (let i = 0; i < name.length; i++) {
        newInfo[name[i]] = value[i]
      }
    } else {
      newInfo[name] = value;
    }

    setOperationLogInfo(newInfo);
  };

  const onSubmit = () => {
    if (operationLogInfo.file === null) {
      Swal.fire(
          '파일은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    /* API 코드 필요 */
    postSysOperationLogWord(operationLogInfo)
        .then((res) => {
          let data = res.data;
          Swal.fire(
              '정상적으로 처리 되었습니다!',
              '',
              'success'
          );
          hClose();
        })
        .catch(err => {
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
  };

  return (
      <Row className={"layer"}>
        <Col className={''}>
          <Row className={'info-container py-2 mx-3'}>
            <Col md={11} className={'px-5'}>
              <div className={'content-container-body-item'}>
                <Form
                    className={'gateway-register-form py-3'}
                    id={'firmwareRegisterForm'}
                >
                  <Row className={"justify-content-center"}>
                    <Col md={12}>
                      <Row>
                        <Col md={12}>
                          <Form.Group as={Row} controlId='forml2IpAddr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>파일명
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='file'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                      console.log(e.target.files[0]);
                                      onChangeInfo('file', e.target.files[0], false);
                                    }
                                  }}
                                  defaultValue={(operationLogInfo !== null) ? operationLogInfo.file : '' || ''}
                                  required
                                  accept={".doc,.docx"}
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
          <Row className={"my-3 justify-content-center"}>
            <Col md={2} className={'justify-content-center'}>
              <Button
                  className={'btn save-btn w-100'}
                  onClick={onSubmit}
              >저장</Button>
            </Col>
            <Col md={2} className={'justify-content-center text-end'}>
              <Button className={'btn btn-secondary w-100'} onClick={hClose}>취소</Button>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};

export default operationLogUpload;
